import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@infra/auth/auth.guard';
import { AdditionalsComponent } from './additionals/additionals.component';
import { HomeComponent } from './home/home.component';
import { PersonComponent } from './person/person.component';
import { RouteService } from './route.service';
import { SuccessComponent } from './success/success.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { PaymentComponent } from './payment/payment.component';
import { ReservationComponent } from './reservation/reservation.component';

const routes: Routes = [
  RouteService.withShell([
    {
      path: 'home',
      component: HomeComponent,
      data: {
        title: 'Página Inicial',
      },
      canActivate: [AuthGuard],
    },
    {
      path: 'home/:preenchimento',
      component: HomeComponent,
      data: {
        title: 'Página Inicial',
      },
      canActivate: [AuthGuard],
    },
    // {
    //   path: 'vehicles',
    //   component: VehiclesComponent,
    //   data: {
    //     title: 'Veículos',
    //   },
    //   canActivate: [AuthGuard],
    // },
    // {
    //   path: 'additionals',
    //   component: AdditionalsComponent,
    //   data: {
    //     title: 'Tarifas e adicionais',
    //   },
    //   canActivate: [AuthGuard],
    // },
    // {
    //   path: 'person',
    //   component: PersonComponent,
    //   data: {
    //     title: 'Identificação',
    //   },
    //   canActivate: [AuthGuard],
    // },
    // {
    //   path: 'payment',
    //   component: PaymentComponent,
    //   data: {
    //     title: 'Pagamento',
    //   },
    //   canActivate: [AuthGuard],
    // },
    {
      path: 'success',
      component: SuccessComponent,
      data: {
        title: 'Reserva finalizada',
      },
      canActivate: [AuthGuard],
    },
    {
      path: 'reservation',
      component: ReservationComponent,
      data: {
        title: 'Reserva',
      },
      canActivate: [AuthGuard],
    },
  ]),
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
